import { useLocation, A } from "@solidjs/router";
import { For } from "solid-js";



const Home = () => <svg
	class="size-6 shrink-0 text-white"
	fill="none"
	viewBox="0 0 24 24"
	stroke-width="1.5"
	stroke="currentColor"
	aria-hidden="true"
	data-slot="icon">
	<path
		stroke-linecap="round"
		stroke-linejoin="round"
		d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>

const Palette = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M496 258.5c-.3 25.3-23.7 45.5-54.1 45.5L344 304c-35.3 0-64 28.7-64 64c0 4.5 .5 9 1.4 13.2c2.5 12 7.7 23.6 12 33.4c0 0 0 0 0 0c.8 1.8 1.6 3.6 2.3 5.3c5.1 11.7 8.2 20.9 8.2 29.8c0 25.5-16.9 45.1-38.1 46c-3.3 .1-6.6 .2-9.9 .2C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 .8 0 1.7 0 2.5zm16 .2c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm8-168a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm88-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z" /></svg>;

const paths = {
	"Dashboard": { path: "/", icon: Home },
	"Collections": { path: "/collections", icon: Palette },
	"Assets": { path: "/assets", icon: Palette },
	"Themes": { path: "/themes", icon: Palette }
}

//const active = ( path ) => useLocation().pathname === path;
export default function Nav() {
	return (
		<>
			<div class="flex grow flex-col gap-y-5 overflow-y-auto bg-genie-blue px-6 pb-4">
				<div class="flex h-16 shrink-0 justify-center items-center">
					<img class="h-12 w-auto" src="/genie.png" alt="Genie Cloud" />
				</div>
				<nav class="flex flex-1 flex-col">
					<ul role="list" class="flex flex-1 flex-col gap-y-7">
						<li>
							<ul role="list" class="-mx-2 space-y-1">
								<For each={Object.keys( paths )}>
									{p =>
										<li>
											<A
												href={paths[p].path}
												class={`group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-white`}
												activeClass="bg-genie-light-blue"
												end={true}
											>
												{p}
												{p.icon}
											</A>
										</li>}
								</For>
							</ul>
						</li>
					</ul>
				</nav>
			</div>

			{/* 

			<div class="lg:pl-72">
				<div
						class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8">
					<button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden">
						<span class="sr-only">Open sidebar</span>
						<svg
							class="size-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							aria-hidden="true"
							data-slot="icon">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
						</svg>
					</button>

					<div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true"></div>
				</div>
			</div>
			*/}
		</>

	);
}

/*

								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-white hover:bg-genie-light-blue ">
										<svg
											class="size-6 shrink-0 text-white"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
											data-slot="icon">
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
										</svg>
										Team
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<svg
											class="size-6 shrink-0 text-genie-light-blue group-hover:text-white"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
											data-slot="icon">
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
										</svg>
										Projects
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<svg
											class="size-6 shrink-0 text-genie-light-blue group-hover:text-white"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
											data-slot="icon">
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
										</svg>
										Calendar
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<svg
											class="size-6 shrink-0 text-genie-light-blue group-hover:text-white"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
											data-slot="icon">
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
										</svg>
										Documents
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<svg
											class="size-6 shrink-0 text-genie-light-blue group-hover:text-white"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
											data-slot="icon">
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" />
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" />
										</svg>
										Reports
									</a>
								</li>




														<li>
							<div class="text-xs/6 font-semibold text-genie-light-blue">Your teams</div>
							<ul role="list" class="-mx-2 mt-2 space-y-1">
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<span
											class="flex size-6 shrink-0 items-center justify-center rounded-lg border border-indigo-400 bg-indigo-500 text-[0.625rem] font-medium text-white">H</span>
										<span class="truncate">Heroicons</span>
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<span
											class="flex size-6 shrink-0 items-center justify-center rounded-lg border border-indigo-400 bg-indigo-500 text-[0.625rem] font-medium text-white">T</span>
										<span class="truncate">Tailwind Labs</span>
									</a>
								</li>
								<li>
									<a
										href="#"
										class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
										<span
											class="flex size-6 shrink-0 items-center justify-center rounded-lg border border-indigo-400 bg-indigo-500 text-[0.625rem] font-medium text-white">W</span>
										<span class="truncate">Workcation</span>
									</a>
								</li>
							</ul>
						</li>
						<li class="mt-auto">
							<a
								href="#"
								class="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-genie-light-blue hover:bg-genie-light-blue hover:text-white">
								<svg
									class="size-6 shrink-0 text-genie-light-blue group-hover:text-white"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									aria-hidden="true"
									data-slot="icon">
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
								</svg>
								Settings
							</a>
						</li> */